import React from 'react'
import { Link } from 'react-router-dom'

export default (props) => {
  let x = 2
  let startPage = (props.page > x) ? props.page - x : 1
  let endPage = (props.page < props.countPages - x) ? props.page + x : props.countPages
  let pages = [...Array(endPage - startPage + 1).keys()].map(x => x + startPage)
  return (
    <nav aria-label='Pagination'>
      <ul className='pagination'>
        <li className={(props.page === 1) ? 'page-item disabled' : 'page-item'}>
          <Link className='page-link' to={props.url + '1'} aria-label='Previous'>
            <span aria-hidden='true'>&laquo;</span>
            <span className='sr-only'>Previous</span>
          </Link>
        </li>
        {(startPage > 1) && <li className='page-item disabled'>
          <Link className='page-link' tabIndex='-1'>...</Link>
        </li>}
        {pages.map(p =>
          <li key={p} className={(p === props.page) ? 'page-item active' : 'page-item'}><Link className='page-link' to={props.url + p}>{p}</Link></li>
        )}
        {(endPage < props.countPages) && <li className='page-item disabled'>
          <Link className='page-link' tabIndex='-1'>...</Link>
        </li>}
        <li className={(props.page === props.countPages) ? 'page-item disabled' : 'page-item'}>
          <Link className='page-link' to={props.url + props.countPages} aria-label='Next'>
            <span aria-hidden='true'>&raquo;</span>
            <span className='sr-only'>Next</span>
          </Link>
        </li>
      </ul>
    </nav>
  )
}
